// Centralised test IDs — drive Playwright/QA against stable selectors.
export const TID = {
  // login / signup
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error",
  signupToggle: "show-signup-link",
  signupFirstName: "signup-first-name",
  signupLastName: "signup-last-name",
  signupEmail: "signup-email",
  signupPassword: "signup-password",
  signupSubmit: "signup-submit-btn",
  signupBackToLogin: "signup-back-to-login",
  stripeModal: "stripe-checkout-modal",
  stripeStatus: "stripe-status-text",

  // shell
  sidebarBrand: "sidebar-brand",
  navDashboard: "nav-dashboard",
  navSetup: "nav-setup",
  navPaymentsEra: "nav-payments-era",
  // Payments & ERA page
  paymentsEraRoot: "payments-era-root",
  paymentsEraUpload: "payments-era-upload-btn",
  paymentsEraRefresh: "payments-era-refresh",
  paymentsEraSearch: "payments-era-search",
  paymentsEraQualifiedToggle: "payments-era-qualified-toggle",
  paymentsEraRangeChip: (id) => `payments-era-range-${id}`,
  paymentsEraTab: (id) => `payments-era-tab-${id}`,
  paymentsEraRow: (id) => `payments-era-row-${id}`,
  paymentsEraRowMenu: (id) => `payments-era-row-menu-${id}`,
  paymentsEraViewEra: (id) => `payments-era-view-${id}`,
  paymentsEraRunValidation: (id) => `payments-era-validate-${id}`,
  paymentsEraAcceptAll: (id) => `payments-era-accept-${id}`,
  paymentsEraModalClose: "payments-era-modal-close",
  signOut: "sign-out-btn",
  userAvatar: "topbar-user-avatar",
  settingsTab: (id) => `settings-tab-${id}`,

  // dashboard
  dashboardRoot: "dashboard-view",
  dashboardSetupPct: "dashboard-setup-pct",
  dashboardContinueSetup: "dashboard-continue-setup-btn",

  // setup wizard
  setupRoot: "setup-view",
  setupProgressPct: "setup-progress-pct",
  stepBtnAccount: "step-btn-account",
  stepBtnProfile: "step-btn-profile",
  stepBtnProviders: "step-btn-providers",
  stepBtnClients: "step-btn-clients",
  stepBtnLink: "step-btn-link",

  // clients step
  clientDescriptionInput: "client-description-input",
  clientAddBtn: "client-add-btn",
  clientsList: "clients-list",
  clientRow: (id) => `client-row-${id}`,

  // providers step
  npiInput: "npi-input",
  npiLookupBtn: "npi-lookup-btn",
  npiResult: "npi-lookup-result",
  providerAddBtn: "provider-add-btn",
  providersList: "providers-list",
  providerRow: (npi) => `provider-row-${npi}`,

  // link step
  linkProviderSelect: "link-provider-select",
  linkClientSelect: "link-client-select",
  linkSubmit: "link-submit-btn",

  // experience mode
  experienceOverlay: "experience-mode-overlay",
  experienceNpiInput: "experience-npi-input",
  experienceValidateBtn: "experience-validate-npi-btn",
  experienceNpiError: "experience-npi-error",
  experienceNpiConfirmed: "experience-npi-confirmed",
  experienceProviderSelect: "experience-provider-select",
  experienceProviderClient: "experience-provider-client",
  experienceProviderTaxonomy: "experience-provider-taxonomy",
  experienceSkipBtn: "experience-skip-btn",
  experienceCloseBtn: "experience-close-btn",
  experienceBackBtn: "experience-back-btn",
  experienceLensSection: "experience-lens-section",
  experienceLensCard: (k) => `experience-lens-card-${k}`,

  // EOB → ERA flow
  eobEraPanel: "eob-era-panel",
  eobEraBackBtn: "eob-era-back-btn",
  eobEraModal: "eob-era-modal",
  eobEraCloseBtn: "eob-era-close-btn",
  eobEraDropzone: "eob-era-dropzone",
  eobEraFileInput: "eob-era-file-input",
  eobEraUploadProgress: "eob-era-upload-progress",
  eobEraProcessing: "eob-era-processing",
  eobEraSummary: "eob-era-summary",
  eobEraDownloadBtn: "eob-era-download-btn",
  eobEraViewRawBtn: "eob-era-view-raw-btn",
  eobEraRawText: "eob-era-raw-835",
  eobEraValidationFailures: "eob-era-validation-failures",
  eobEraError: "eob-era-error",
  eobEraRetryBtn: "eob-era-retry-btn",
  eobEraRecheckBtn: "eob-era-recheck-btn",
  eobEraDeepRecoveryBtn: "eob-era-deep-recovery-btn",
  eobEraTryAnotherBtn: "eob-era-try-another-btn",
  eobEraDiscardBtn: "eob-era-discard-btn",

  // Single document → one claim (note-to-claim) flow
  noteClaimPanel: "note-claim-panel",
  noteClaimBackBtn: "note-claim-back-btn",
  noteClaimUploadProgress: "note-claim-upload-progress",
  noteClaimProcessing: "note-claim-processing",
  noteClaimResult: "note-claim-result",
  noteClaimError: "note-claim-error",
  noteClaimRetryBtn: "note-claim-retry-btn",
  noteClaimReprocessBtn: "note-claim-reprocess-btn",
  noteClaimDiscardBtn: "note-claim-discard-btn",
  noteClaimTryAnotherBtn: "note-claim-try-another-btn",
  noteClaimIcdList: "note-claim-icd-list",
  noteClaimCptList: "note-claim-cpt-list",
  noteClaimMatchBanner: "note-claim-match-banner",
  noteClaimValidationToggle: "note-claim-validation-toggle",
  noteClaimValidationSteps: "note-claim-validation-steps",
  // Note-claim rich result modal (v19)
  noteClaimResultModal: "note-claim-result-modal",
  noteClaimResultClose: "note-claim-result-close",
  noteClaimDownload837: "note-claim-download-837",
  noteClaimSourceBtn: "note-claim-source-btn",
  noteClaimCptRow: (i) => `note-claim-cpt-row-${i}`,
  noteClaimScrubPanel: "note-claim-scrub-panel",
  noteClaimResultTryAnother: "note-claim-result-try-another",
  noteClaimResultFinish: "note-claim-result-finish",
  noteClaimViewBtn: "note-claim-view-btn",
  noteClaimSwitcher: "note-claim-switcher",
  noteClaimSwitcherTab: (i) => `note-claim-switcher-tab-${i}`,
  // Batch docs → many claims flow
  batchClaimPanel: "batch-claim-panel",
  batchClaimError: "batch-claim-error",
  batchClaimUploadProgress: "batch-claim-upload-progress",
  batchClaimProcessing: "batch-claim-processing",
  batchClaimResult: "batch-claim-result",
  batchClaimViewBtn: "batch-claim-view-btn",

  // ERA (835) friendly view modal
  eraViewModal: "era-view-modal",
  eraViewClose: "era-view-close-btn",
  eraViewBackBtn: "era-view-back-btn",
  eraViewOriginalBtn: "era-view-original-btn",
  eraViewDownloadBtn: "era-view-download-btn",
  eraViewRawToggle: "era-view-raw-toggle",
  eraViewOpenBtn: "era-view-open-btn",
  eraViewChooseFlowBtn: "era-view-choose-flow-btn",
  eraViewSourceBtn: "era-view-source-btn",
  eraViewFinishBtn: "era-view-finish-btn",
  eraViewClaimRow: (i) => `era-view-claim-row-${i}`,
  eraViewLegendCode: (code) => `era-view-legend-${String(code).replace(/[^a-zA-Z0-9]/g, "-")}`,
  eraViewClearFilter: "era-view-clear-filter",
};
